module.exports = __webpack_public_path__ + "img/company3-2.57486868.jpg";